import React, { useState, useEffect } from 'react';
import { collection, addDoc, getDocs } from '@firebase/firestore';
import { useAuth } from '../service/AuthContext';
import { useGlobalContext } from '../context/GlobalContext';
import { db } from '../service/Firebase-config';
import SingleSelectTreeView from '../common/SingleSelectTreeView';
import {
  FormControl,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Box,
  InputLabel,
  MenuItem,
  Select,
  Avatar
} from '@mui/material';

export default function DialogNewHomework({ open, closeNewHomework, isAdmin = false }) {
  const { currentUser } = useAuth();
  const { selectedUser} = useGlobalContext();
  const [subject, setSubject] = useState('');
  const [selectedTeacherUid, setSelectedTeacherUid] = useState('');
  const [teacherList, setTeacherList] = useState([]);

  useEffect(() => {
    const fetchTeachers = async () => {
      const snapshot = await getDocs(collection(db, "teachers"));
      const list = snapshot.docs.map(doc => ({
        uid: doc.id,
        displayName: doc.data().displayName,
        photoUrl: doc.data().photoUrl
      }));
      setTeacherList(list);
    };
  
    if (isAdmin) fetchTeachers();
  }, [isAdmin]);

  const handleSubjectChange = (sbj) => {
    setSubject(sbj);
  };

  const handleClose = () => {
    setSubject();
    closeNewHomework();
    setSelectedTeacherUid("");
  };
  
  const saveNewHomework = async (sbjt, hmwk, cmnt) => {
    const homeworkData = {
      createdDate: new Date(),
      subject: sbjt,
      homework: hmwk,
      teacherUid: isAdmin ? selectedTeacherUid : currentUser.uid,
      isHwOpen: false,
      isNewComment: !!cmnt && cmnt.length > 0, 
    };

    const dbCollection = collection(db, `students/${selectedUser.uid}/homeworks`);
    try {
      const data = await addDoc(dbCollection, homeworkData);
      if (cmnt && cmnt !== '') {
        const commentData = {
          createdDate: new Date(),
          comment: cmnt,
          fromWhom: 'teacher',
        };
        const commentsCollection = collection(db, `students/${selectedUser.uid}/homeworks/${data.id}/comments`);
        await addDoc(commentsCollection, commentData);
      }

    } catch (e) {
      alert(`Error! ${e.message}`);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const formJson = Object.fromEntries(formData.entries());
    const homework = formJson.homework;
    const comment = formJson.comment;

    if (isAdmin && !selectedTeacherUid) {
      alert("Please select a teacher.");
      return;
    }
    
    saveNewHomework(subject, homework, comment);
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>New Homework</DialogTitle>
      <DialogContent>
        <form onSubmit={handleSubmit}>
        {isAdmin && (
          <Box sx={{ mt: 2, mb: 2 }}>
            <FormControl fullWidth>
              <InputLabel id="teacher-select-label">Select Teacher by Admin </InputLabel>
              <Select
                required={isAdmin}
                labelId="teacher-select-label"
                value={selectedTeacherUid}
                label="Select Teacher"
                onChange={(e) => setSelectedTeacherUid(e.target.value)}
              >
                {teacherList.map((teacher) => (
                  <MenuItem key={teacher.uid} value={teacher.uid}>
                    <Box display="flex" alignItems="center" gap={1}>
                      <Avatar
                        src={teacher.photoUrl}
                        alt={teacher.displayName}
                        sx={{ width: 30, height: 30 }}
                      />
                      {teacher.displayName}
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        )}
          <Box sx={{ mt: 2, mb: 2 }}>
            <FormControl fullWidth>
              <SingleSelectTreeView 
                selectedSubject={subject}
                onSelect={handleSubjectChange} 
              />
            </FormControl>
          </Box>
          <TextField
            autoFocus
            required
            margin="dense"
            id="homework"
            name="homework"
            label="Homework"
            multiline
            rows={4}
            fullWidth
            variant="outlined"
          />
          <TextField
            margin="dense"
            id="comment"
            name="comment"
            label="Message"
            multiline
            rows={2}
            fullWidth
            variant="outlined"
          />
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button 
              type="submit" 
              variant="contained" 
              color="primary" 
              disabled={!subject}
            >
              Save
            </Button>
          </DialogActions>
        </form>
      </DialogContent>
    </Dialog>
  );
}
